import styled from "styled-components";

export const GridGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
`;

export const NavWrapper = styled.div`
  display: flex;
  /* align-items: center; */
  justify-content: center;
  /* margin-bottom: -5px; */
  font-family: "Nunito";
  .nav-link {
    cursor: pointer;
    /* background-color: #f8f8f8 !important; */
    margin: 2px;
    text-align: center;
    border-bottom: solid 2px rgba(238, 49, 36, 0.5) !important;
  }
  .active {
    background-color: #ffffff !important;
    color: #f0292a !important; // Grey2
    font-weight: 800;
    border: none !important;
    border-bottom: solid 2px #f0292a !important;
  }
  .nav {
    /* margin-left: 2.5rem !important; */
    width: -webkit-fill-available !important;
    display: flex !important;
    /* justify-content: space-between !important; */
  }

  .nav-tabs {
    border-bottom: none !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .nav-item {
    background-color: #ffffff !important;
    margin: 0 5px;
    /* width: 23%; */
    width: fit-content;
  }
`;

export const ArrowButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &:focus {
    outline: none;
  }
  &::selection {
    outline: none;
  }
  &:hover {
    color: #f0292a;
  }
`;

export const SimulatedSlash = styled.span`
  position: absolute;
  top: 11px;
  right: 22px;
  width: 60%;
  height: 100%;
  background-color: transparent;
  border-top: 2px solid rgb(240, 41, 42);
  transform: rotate(45deg);
  pointer-events: none;
`;
